














import { Component, Vue } from "vue-property-decorator";
import { mapGetters, mapActions } from "vuex";
import Header from "@/components/Header.vue";
import Description from "@/components/Description.vue";
import SectionList from "@/components/SectionList.vue";
import ContactList from "@/components/ContactList.vue";

@Component({
  components: {
    Header,
    Description,
    SectionList,
    ContactList
  },
  computed: {
    ...mapGetters("info", ["description", "avatar", "contact", "tags"]),
    ...mapGetters("sections", ["sections"])
  },
  methods: {
    ...mapActions("info", ["fetchInfo"]),
    ...mapActions("sections", ["fetchSections"])
  }
})
export default class Home extends Vue {
  fetchInfo!: () => void;
  fetchSections!: () => void;

  created() {
    this.fetchInfo();
    this.fetchSections();
  }
}
